import React, { useReducer } from 'react';

const AuthContext = React.createContext();

const AuthProvider = (props) => {

    const initalState = { 
        id: localStorage.id,
        username: localStorage.username,
        accessToken: localStorage.accessToken,
        refreshToken: localStorage.refreshToken
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'setToken':
                return {
                    ...state,
                   id: action.payload.id,
                   username: action.payload.username,
                   accessToken: action.payload.accessToken,
                   refreshToken: action.payload.refreshToken
                }
            case 'initialize':
                return {
                    ...state,
                    id: null,
                    username: null,
                    accessToken: null,
                    refreshToken: null
                }
            default:
                throw new Error();
        }
    }

    const [authState, dispatch] = useReducer(reducer, initalState);

    const isAuthenticated = () => {
        return (authState.accessToken !== null && authState.accessToken !== undefined);
    }

    const accessToken = () => {
        return authState.accessToken;
    }

    const loggedIn = (id, username, accessToken, refreshToken, callback) =>
    {
        localStorage.id = id;
        localStorage.accessToken = accessToken;
        localStorage.refreshToken = refreshToken;
        localStorage.username = username;

        dispatch({ type: 'setToken', payload: {id, username, accessToken, refreshToken} })
        callback()
    }

    const login = (username, password, success, failure) => {
        fetch('api/auth/login', { 
            method: "POST",
            headers: {  "Content-Type": "application/json; charset=utf-8"},
            body: JSON.stringify({ username: username, password: password })
        })
        .then(response => {
            if (response.ok) { 
                return response.json(); 
            }
            throw new Error('Login failed. Please try again.');
        })
        .then(data => {
            loggedIn(data.id, data.username, data.accessToken, data.refreshToken, success);
        })
        .catch(error=>{
            if (typeof(failure) === "function")
            {
                failure(error.message);
            }
        });
    }

    const refresh = (success, failure) => {
        return fetch('api/auth/refresh', { 
            method: "POST",
            headers: {  "Content-Type": "application/json; charset=utf-8"},
            body: JSON.stringify({ AccessToken: localStorage.accessToken, refreshToken: localStorage.refreshToken })
        })
    }

    const init = (callback) => {
        delete localStorage.id;
        delete localStorage.accessToken;
        delete localStorage.refreshToken;
        delete localStorage.username;

        dispatch({ type: 'initialize' })

        if (typeof(callback) === "function") {
            callback()
        }
    }

    const logout = () => {
        init();
    }

    return (
        <AuthContext.Provider 
            value={{ 
                accessToken: authState.accessToken,
                refreshToken: authState.refreshToken,
                username: authState.username,
                login: login,
                // impersonate: impersonate,
                logout: logout,
                refresh: refresh,
                loggedIn: loggedIn,
                isAuthenticated: isAuthenticated
            }} >
            {props.children}
        </AuthContext.Provider>
    )
}

const AuthConsumer = AuthContext.Consumer;

export { AuthContext, AuthProvider, AuthConsumer };
